//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BUTTON_THEME_DEFAULT } from "../../../assets/js/constants/button";
import { BUTTON_THEMES } from "../../../assets/js/enumerators/button";

export default {
  name: "S2ButtonInline",
  components: {
    IconSpinner: () => import("../spinners/IconSpinner.vue"),
  },
  props: {
    active: Boolean,
    disabled: Boolean,
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    loading: Boolean,
    theme: {
      type: String,
      default: BUTTON_THEME_DEFAULT,
      validator: (theme) => {
        return Object.values(BUTTON_THEMES).includes(theme);
      },
    },
  },
  computed: {
    activeThemeClass() {
      return `theme-${this.theme}`;
    },
  },
  methods: {
    handleClick() {
      !this.disabled && !this.loading && this.$emit("click");
    },
  },
};
